import logoWhite from '../assets/logo-white.svg';
import trophienLogo from '../assets/trophien.svg';
import paymentMethods from '../assets/payment methods.png';

function Footer() {
  const actualYear = new Date().getFullYear();

  return (
    <div className='Footer'>
      <footer>
        <div className='container'>
          <div className='row py-2'>
            <div className='col-4 d-flex align-items-center'>
              <img src={logoWhite} alt='sb-dt' className='img-fluid img-logo' />
            </div>
            <div className='col-4 d-flex justify-content-start align-items-center'>
              <img src={paymentMethods} alt='Payment methods' className='img-fluid img-payment' />
            </div>
            <div className='col-4 d-flex justify-content-end align-items-center'>
              <img src={trophienLogo} alt='Trophien' className='img-fluid img-trophien' />
              <p className='ps-2'>{actualYear}</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footer;